export interface AppConfiguration {
  app_name: string;
  configurations?: Record<string, any>;
  is_active: boolean;
  _redacted?: string[];
}

export interface ConfigurationApiResponse {
  internal: AppConfiguration[];
  external: AppConfiguration[];
}

// New API response structure - flat array
export type ConfigurationApiResponseFlat = AppConfiguration[];

export interface ProcessedService {
  app_name: string;
  display_name: string;
  configurations: Record<string, any>;
  is_active: boolean;
  type: "internal" | "external";
  description?: string;
}

export interface ThirdPartyServicesFormData {
  services: ProcessedService[];
}

export interface PriceTier {
  id: string;
  name: string;
  minQuantity: number;
  discountType: "percentage" | "fixed";
  discountValue: number;
  isActive: boolean;
}

export interface TieredPricingFormData {
  tiers: PriceTier[];
  isEnabled: boolean;
}

export const formatAppName = (appName: string): string => {
  return appName
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const generateDescription = (appName: string): string => {
  const descriptions: Record<string, string> = {
    google_analytics: "Track website analytics and user behavior",
    google_tag_manager: "Manage marketing and analytics tags",
    google_adsense: "Display ads on your website",
    google_recaptcha: "Protect forms from spam and abuse",
    google_maps: "Enable location services and mapping",
    google_search_console: "Verify site ownership and submit sitemaps",
    "tiered-pricing": "Manage tiered pricing configurations",
    tiered_pricing: "Manage tiered pricing configurations",
    dealer_locator: "Enable dealer location services",
  };

  return descriptions[appName] || `Configure ${formatAppName(appName)} integration`;
};
